'use strict';
import { Howl } from 'howler';

class BGMController extends Howl {
  constructor(path, html5) {
    super({
      src: [path],
      preload: true,
      html5: html5,
      sprite: {
        proc_play04sushi: [0, 31111.836734693876],
      },
    });

    this.spriteKeys = ['proc_play04sushi'];
  }

  hasKey(key) {
    return this.spriteKeys.includes(key);
  }
}

export default BGMController;
